import { User } from '../types';

export const getCurrentPath = (path: string, user: User | null): string => {
  return path
    .replace(':orgId', user?.orgId || '')
    .replace(':userId', user?.userId || '');
};
